import { apiService } from '../../../services/apiService';
import {
  API_PATHS,
  getDeleteErrorMappingPath,
  getToggleErrorMappingPath,
  getUpdateErrorMappingPath,
} from '../../../utils/apiPaths';
import type {
  ErrorCatalogRow,
  ErrorMapping,
  ErrorMappingPayload,
  ErrorMappingTerminal,
} from '../models/types';

function unwrap<T>(res: any, fallback: T): T {
  if (!res?.success) throw new Error(res?.message || 'Request failed.');
  return (res.data ?? fallback) as T;
}

export async function fetchErrorMappingTerminals(): Promise<ErrorMappingTerminal[]> {
  const res: any = await apiService.get(API_PATHS.GET_ERROR_MAPPING_TERMINALS);
  return unwrap<ErrorMappingTerminal[]>(res, []);
}

export async function fetchErrorCatalog(acquirerTerminalId: number): Promise<ErrorCatalogRow[]> {
  const res: any = await apiService.get(
    `${API_PATHS.GET_ERROR_CATALOG}?acquirerTerminalId=${acquirerTerminalId}`,
  );
  return unwrap<ErrorCatalogRow[]>(res, []);
}

export async function fetchErrorMappings(acquirerTerminalId: number): Promise<ErrorMapping[]> {
  const res: any = await apiService.get(
    `${API_PATHS.GET_ERROR_MAPPINGS}?acquirerTerminalId=${acquirerTerminalId}`,
  );
  return unwrap<ErrorMapping[]>(res, []);
}

export async function createErrorMapping(payload: ErrorMappingPayload): Promise<ErrorMapping> {
  const res: any = await apiService.post(API_PATHS.CREATE_ERROR_MAPPING, payload);
  return unwrap<ErrorMapping>(res, {} as ErrorMapping);
}

export async function updateErrorMapping(
  id: number,
  payload: ErrorMappingPayload,
): Promise<ErrorMapping> {
  const res: any = await apiService.put(getUpdateErrorMappingPath(id), payload);
  return unwrap<ErrorMapping>(res, {} as ErrorMapping);
}

export async function setErrorMappingActive(id: number, active: boolean): Promise<void> {
  const res: any = await apiService.patch(getToggleErrorMappingPath(id, active), {});
  unwrap(res, null);
}

export async function deleteErrorMapping(id: number): Promise<void> {
  const res: any = await apiService.post(getDeleteErrorMappingPath(id), {});
  unwrap(res, null);
}
